<template>
  <div>
    <div
      v-for="(bank,bIndex) in dataList"
      :key="bank.id"
    >
      <b-card-header>
        <b-card-title>{{ bank.title }}</b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <total-card
              card-title="Gelirler Toplamı"
              card-color="success"
              card-icon="CheckCircleIcon"
              :card-amount="bank.income_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Giderler Toplamı"
              card-color="danger"
              card-icon="XCircleIcon"
              :card-amount="bank.expense_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Güncel Bakiye"
              card-color="primary"
              card-icon="CheckCircleIcon"
              :card-amount="bank.total_amount"
            />
          </b-col>
          <b-col>
            <total-card
              card-title="Devir Toplamı"
              card-color="info"
              card-icon="RefreshCwIcon"
              :card-amount="bank.carryover_amount"
            />
          </b-col>
        </b-row>
      </b-card-body>
      <b-table-simple
        borderless
        striped
        responsive="sm"
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th
              class="text-center width-50"
            >
              <FeatherIcon icon="EyeIcon" />
            </b-th>
            <b-th>Tanım</b-th>
            <b-th class="width-200 text-right text-nowrap">
              Gelirler Toplamı
            </b-th>
            <b-th class="width-200 text-right text-nowrap">
              Giderler Toplamı
            </b-th>
            <b-th class="width-200 text-right text-nowrap">
              Güncel Bakiye
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="(item,index) in bank.types">
            <b-tr :key="item.id">
              <b-td class="text-center">
                <b-button
                  :variant="item.toggle? 'flat-danger' : 'flat-success'"
                  pill
                  class="btn-icon"
                  @click="toggleDetail(bIndex,index)"
                >
                  <FeatherIcon :icon="item.toggle? 'EyeOffIcon' : 'EyeIcon'" />
                </b-button>
              </b-td>
              <b-td>
                {{ item.title }}
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-success">
                {{ item.income_amount | toCurrency }} TL
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-danger">
                {{ item.expense_amount | toCurrency }} TL
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold text-primary">
                {{ item.total_amount | toCurrency }} TL
              </b-td>
            </b-tr>
            <template
              v-for="subitem in item.items"
            >
              <b-tr
                v-if="item.toggle"
                :key="subitem.id + '_' + index"
                class="text-secondary"
              >
                <b-td />
                <b-td>
                  {{ subitem.title }}
                  <div class="font-small-2 text-warning">
                    {{ subitem.donation_type }}
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-success">
                  <div v-if="subitem.is_income">
                    {{ subitem.income_amount | toCurrency }} TL
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-danger">
                  <div v-if="subitem.is_expense">
                    {{ subitem.expense_amount | toCurrency }} TL
                  </div>
                </b-td>
                <b-td class="text-right text-nowrap font-weight-bold text-primary">
                  {{ subitem.total_amount | toCurrency }} TL
                </b-td>
              </b-tr>
            </template>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th />
            <b-th>
              Genel Toplam
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.income_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.expense_amount | toCurrency }} TL
            </b-th>
            <b-th class="text-right text-nowrap">
              {{ grandTotal.total_amount | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </div>
  </div>
</template>
<script>
import {
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BTfoot,
  BButton,
} from 'bootstrap-vue'
import TotalCard from '@/views/Admin/Reports/Banks/components/TotalCard.vue'

export default {
  name: 'ReportTable',
  components: {
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTfoot,
    BButton,
    TotalCard,
  },
  computed: {
    dataList() {
      return this.$store.getters['banksReports/dataList']
    },
    grandTotal() {
      return this.$store.getters['banksReports/grandTotal']
    },
  },
  methods: {
    toggleDetail(bIndex, index) {
      this.dataList[bIndex].types[index].toggle = !this.dataList[bIndex].types[index].toggle
    },
  },
}
</script>
